import { render, staticRenderFns } from "./SquareButton.vue?vue&type=template&id=12fae940"
import script from "./SquareButton.vue?vue&type=script&lang=js"
export * from "./SquareButton.vue?vue&type=script&lang=js"
import style0 from "./SquareButton.vue?vue&type=style&index=0&id=12fae940&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports